import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * 報修單 Detail（含 lines／history／record）。
 *
 * @param {string} id
 */
export async function fetchRepairRequestDetail(id) {
  const { data: raw } = await request.get(`/aftersales/repair-request/${id}`);
  return parseVer4DetailResponse(raw);
}
